import { useQuery } from '@apollo/client';
import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

import { GetActivityCenterTotalsDocument } from './graphql/get-activity-center-totals.gql-types';
import { usePrevious } from './utils';

const EVENTS = ['jobBookmarks'];

type UseTotalsResult = {
  total: number;
  totalByEvents: Record<string, number>;
  previousTotalByEvents: Record<string, number> | undefined;
  refetch: () => void;
  setTotalByEvents: Dispatch<SetStateAction<Record<string, number>>>;
};

export function useTotals(skip = false): UseTotalsResult {
  const [total, setTotal] = useState(0);
  const [totalByEvents, setTotalByEvents] = useState<Record<string, number>>(
    {}
  );
  const previousTotalByEvents = usePrevious(totalByEvents);

  const { refetch } = useQuery(GetActivityCenterTotalsDocument, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    skip: skip,
    onCompleted: (data) => {
      const totalByEvents: Record<string, number> = {
        jobBookmarks: data?.viewer?.jobBookmarks?.total ?? 0,
      };

      setTotalByEvents(totalByEvents);
      setTotal(EVENTS.reduce((acc, event) => acc + totalByEvents[event], 0));
    },
  });

  return {
    total,
    totalByEvents,
    previousTotalByEvents,
    refetch,
    setTotalByEvents,
  };
}
